<div class="schema-display">
  <ng-container *ngFor="let level of schema; let i = index">
    <span *ngIf="level.italic" class="schema-italic">{{ level.label }}</span>
    <ng-container *ngIf="!level.italic">
      <span *ngIf="showArrow(i)" class="schema-arrow">›</span>
      <div class="schema-level" [class.first]="i === 0">
        <div class="schema-dot" style="background: var(--navy)"></div>
        {{ level.label }}
      </div>
    </ng-container>
  </ng-container>
</div>
